import { useAppSelector } from "../../app/hooks";
import { UserRole } from "../../app/userSlice";
import StudentPeerReviews from "./StudentPeerReviews";
import TeacherPeerReviews from "./TeacherPeerReviews";

export default function PeerReviews() {
	const role = useAppSelector((state) => state.user.role);

	return role === UserRole.Writer ? <StudentPeerReviews /> : <TeacherPeerReviews />;
}
